import { render } from "./VendorActive.vue?vue&type=template&id=85d8ad88"
import script from "./VendorActive.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorActive.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Vendor/VendorActive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85d8ad88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85d8ad88', __exports__)) {
    api.reload('85d8ad88', __exports__)
  }
  
  module.hot.accept("./VendorActive.vue?vue&type=template&id=85d8ad88", () => {
    api.rerender('85d8ad88', render)
  })

}


export default __exports__